// extracted by mini-css-extract-plugin
export var bold = "_rh-0";